import { useNavigate } from 'react-router-dom';

export default function TWFooter() {
  const navigate = useNavigate();

  return (
    <footer className="bg-zinc-100 border-t border-zinc-200 py-10">
      <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <a
          href="/"
          onClick={(e) => { e.preventDefault(); navigate('/'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <div className="w-7 h-7 flex items-center justify-center bg-orange-500 rounded-md">
            <i className="ri-rocket-2-fill text-white text-xs" />
          </div>
          <span className="text-zinc-800 font-bold text-lg tracking-tight">
            boost<span className="text-orange-500">io</span>
          </span>
        </a>

        <p className="text-zinc-400 text-sm text-center">
          © {new Date().getFullYear()} Boostio. Všetky práva vyhradené.
        </p>

        <div className="flex items-center gap-5">
          <a href="/ochrana-sukromia" className="text-zinc-400 hover:text-zinc-700 text-xs transition-colors cursor-pointer">
            Ochrana súkromia
          </a>
          <a href="/obchodne-podmienky" className="text-zinc-400 hover:text-zinc-700 text-xs transition-colors cursor-pointer">
            Obchodné podmienky
          </a>
        </div>
      </div>
    </footer>
  );
}
